import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import HopkinsLogo from '../../img/johnhopkinslogo.jpg';
import MHALogo from '../../img/mhalogo.jpg';
import CCLogo from '../../img/cclogo.jpg';
import styles from './home.module.scss';

const HomeAction = () => {
    return (<>
        <div className={styles.light}>
            <Container className={styles.mainContainer}>
                <h3>AHRQ QIs in Action</h3>
                <Row className="mb-5">
                    <Col xs={{ span: 12, order: 2 }} sm={{ span: 12, order: 2 }} md={{ span: 8, order: 1 }}>
                        <p>The Johns Hopkins Hospital worked diligently to improve its performance for Postoperative Respiratory Failure (PSI 11). The effort started back in 2012 when only 30 percent were able to be removed from a ventilator within the desired timeframe. Today, nearly 60 percent of cardiac patients are taken off a ventilator in less than six hours following surgery.</p>
                        <a href="https://www.qualityindicators.ahrq.gov/Downloads/Resources/Case_Studies/Johns_Hopkins_Case_Study.pdf">See the full story</a>
                    </Col>
                    <Col xs={{ span: 12, order: 1 }} sm={{ span: 12, order: 1 }} md={{ span: 4, order: 2 }}>
                        <img className={styles.actionImages} src={HopkinsLogo} />
                    </Col>
                </Row>
                <Row className="mb-5">
                    <Col xs={{ span: 12, order: 2 }} sm={{ span: 12, order: 2 }} md={{ span: 8, order: 1 }}>
                        <p>After examining its rate of Iatrogenic Pneumothorax (PSI 06), Carilion Roanoke Memorial Hospital, part of the Carilion Clinic health system, instituted a residency simulation program that decreased its rate for this Patient Safety Indicator (PSI) by over 50 percent.</p>
                        <a href="https://www.qualityindicators.ahrq.gov/Downloads/Resources/Case_Studies/Carilion_Clinic_Case_Study.pdf">See the full story</a>
                    </Col>
                    <Col xs={{ span: 12, order: 1 }} sm={{ span: 12, order: 1 }} md={{ span: 4, order: 2 }}>
                        <img className={styles.actionImages} src={CCLogo} />
                    </Col>
                </Row>
                <Row className="mb-5">
                    <Col xs={{ span: 12, order: 2 }} sm={{ span: 12, order: 2 }} md={{ span: 8, order: 1 }}>
                        <p>Missouri Hospital Association launched a public reporting website that uses a range of AHRQ QIs to support greater statewide transparency on hospital quality and cost. Initially a voluntary effort, the state legislature now mandates that all Missouri hospitals report pricing data for the 100 most common Diagnostic-Related Groups.</p>
                        <a href="https://www.qualityindicators.ahrq.gov/Downloads/Resources/Case_Studies/AHRQ_QI_MOHA_Case_Study.pdf">See the full story</a>
                    </Col>
                    <Col xs={{ span: 12, order: 1 }} sm={{ span: 12, order: 1 }} md={{ span: 4, order: 2 }}>
                        <img className={styles.actionImages} src={MHALogo} />
                    </Col>
                </Row>
            </Container>
        </div>
    </>)
}

export default HomeAction;